// extracted by mini-css-extract-plugin
module.exports = {"icon":"coinIcon_icon__15gZH","white":"coinIcon_white__2q_Dm"};